import { memo, type ReactNode } from "react";
import { styled } from "styled-components";

import { Tooltip } from "@/components/ui/Tooltip";
import {
    type TableHeaderCellProps,
    TableHeaderCellStyled,
} from "@/components/ui/table-final-saviour/Table/TableHeaderCell/TableHeaderCell";
import { Row } from "@/components/ui/table-final-saviour/Table/table.types";

const TooltipTriggerStyled = styled.span`
    text-decoration: underline dotted;
`;

const TooltipStyled = styled(Tooltip)`
    z-index: ${({ theme }) => theme.zIndex.tableFinalSaviourHeader + 1};
`;

interface Props<T extends Row> extends TableHeaderCellProps<T> {
    tooltip: ReactNode;
}

const TableHeaderCellWithTooltip = <T extends Row>(props: Props<T>) => {
    return (
        <TableHeaderCellStyled className={props.className} $align={props.align} $width={props.width}>
            <TooltipStyled content={props.tooltip} asChild>
                <TooltipTriggerStyled>{props.children}</TooltipTriggerStyled>
            </TooltipStyled>
        </TableHeaderCellStyled>
    );
};

const TableHeaderCellWithTooltipMemo = memo(TableHeaderCellWithTooltip) as typeof TableHeaderCellWithTooltip;

export { TableHeaderCellWithTooltipMemo as TableHeaderCellWithTooltip };
